export const hasBodyClass = (className) => {
  return document.body.classList.contains(className);
};

export function formatDate (dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-AU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export function getCurrencySymbol(fallback = null) {
  return window.Alpine?.store('currency')?.getCurrencySymbol() ?? fallback;
}

// For displaying a specific currency (e.g. a past order's own currency), not the shopper's
// currently-browsing market - looks up the symbol from the already-fetched enabled currencies list.
export function getCurrencySymbolForCode(code, fallback = null) {
  return window.Alpine?.store('currency')?.getSymbolByCurrencyCode(code) ?? fallback;
}

export function isCurrencyResolved() {
  return !!window.Alpine?.store('currency')?.resolved;
}

// Runs callback immediately if currency has already resolved, otherwise waits for it.
// Returns a cleanup function to remove the listener if the caller unmounts first.
export function onCurrencyResolved(callback) {
  if (isCurrencyResolved()) {
    callback();
    return () => {};
  }

  window.addEventListener('currency:resolved', callback);
  return () => window.removeEventListener('currency:resolved', callback);
}

export const sendGtagEvent = (event, promotion_id, promotion_name, creative_name, url) => {
  if (window.gtag) {
    window.gtag('event', event, {
      promotion_id,
      promotion_name,
      creative_name,
      event_timeout: 350,
      event_callback: () => {
        if (url) window.location.assign(url);
      }
    });
  }

  // Fallback in case GA4 takes too long
  if (url) {
    setTimeout(() => {
      window.location.assign(url);
    }, 1350);
  }
}

export default {
  /**
   * Emit a custom event
   * @param  {String} type   The event type
   * @param  {Object} detail Any details to pass along with the event
   * @param  {Node}   elem   The element to attach the event to
   */
  emitEvent(type, detail = {}, elem = document) {
    if (!type) return;

    let event = new CustomEvent(type, {
      bubbles: true,
      cancelable: true,
      detail: detail,
    });

    return elem.dispatchEvent(event);
  },
  getDomain(use_local = true, use_shop = false) {
    if (use_local) {
        if (
            location.origin.includes("127.0.0.1") ||
            location.origin.includes("localhost")
        ) {
            return location.origin;
        }
    }
    if (use_shop) return `https://${Shopify.shop}`; 
    return `https://${window.location.host}`;
  },
  randomNumber(min = 0, max = 1000) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  },
  truncateLongTitle(input) {
    return input.length > 5 ? `${input.substring(0, 18)}...` : input;
  },
  async fetchHTML(endpoint) {
    return await fetch(endpoint)
      .then((response) => response.text())
      .then((responseText) => {
        return new DOMParser().parseFromString(responseText, "text/html");
      });
  },

  updateUrlParameters(originalUrl, params) {
    const url = new URL(originalUrl.toString());

    for (const [key, value] of Object.entries(params)) {
      if (!value) {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value.toString());
      }
    }

    return url.toString();
  },
};
